import { useQuery } from "@tanstack/react-query";
import api from "../lib/api";
import { Field } from "./DocumentCardParts";
import { Input } from "./ui/input";

// Optional manual number on a new document; blank = next number in the series.
export function DocNoField({ counter, value, onChange, testid = "card-doc-no" }) {
  const { data = [] } = useQuery({ queryKey: ["number-series"], queryFn: async () => (await api.get("/number-series")).data });
  const s = data.find((x) => x.id === counter);
  return (
    <Field label="No.">
      <Input value={value} onChange={(e) => onChange(e.target.value.replace(/\s/g, ""))} maxLength={30} className="rounded-sm font-mono"
        placeholder={s ? `${s.example} (automatic)` : "Automatic"} data-testid={testid} />
    </Field>
  );
}
